import type EditorType from '../../../Enums/EditorType';

abstract class ChecklistElement {

    protected _elementId: string;
    protected _name: string;
    protected _itemNumber: string | null;
    protected _sortNumber: number;
    protected _editorType: EditorType; //used when restoring from indexedDB object as the type of the elements are lost

    public constructor(elementId: string, name: string, itemNumber: string | null, sortNumber: number, editorType: EditorType) {

        this._elementId = elementId;
        this._name = name;
        this._itemNumber = itemNumber;
        this._sortNumber = sortNumber;
        this._editorType = editorType;
    }

    public get elementId(): string {
        return this._elementId;
    }

    public set elementId(value: string) {
        this._elementId = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get itemNumber(): string | null {
        return this._itemNumber;
    }

    public set itemNumber(value: string | null) {
        this._itemNumber = value;
    }

    public get sortNumber(): number {
        return this._sortNumber;
    }

    public set sortNumber(value: number) {
        this._sortNumber = value;
    }

    public get editorType(): EditorType {
        return this._editorType;
    }

    public set editorType(value: EditorType) {
        this._editorType = value;
    }
}

export default ChecklistElement;